import "./LandingFooter.css";

function LandingFooter() {
  return (
    <footer className="landing-footer">
      <a className="landing-footer__linkedin" href="https://www.linkedin.com/company/kurtosis-bv" aria-label="LinkedIn">
        <span className="landing-footer__linkedin-mark">in</span>
      </a>
      <div className="landing-footer__copy">(c) Kurtosis B.V.</div>
    </footer>
  );
}

export default LandingFooter;
